import { ECheckServicePublicationType } from '../../../services/checkService';

export const PACKAGE_TYPES = [
  ECheckServicePublicationType.PromotionPackage,
  ECheckServicePublicationType.PublicationPackage,
];

export const PUBLICATION_TYPES = [ECheckServicePublicationType.Publication];
